<template>
  <b-overlay :show="loading" rounded="sm" spinner-variant="primary">
    <transition name="bounce">
      <b-container class="py-5 custom-container container">
        <b-breadcrumb
          :items="items"
          class="pl-0 pt-5 mt-5 bg-transparent text-capitalize"
        ></b-breadcrumb>
        <b-card v-if="providers.length === 0 && !loading">
          <b-card-title>
            <h5 class="font-weight-bold text-center mt-2">
              No data for providers.
            </h5>
          </b-card-title>
        </b-card>
        <b-row v-else class="ml-auto">
          <b-col
            :md="3"
            :cols="12"
            class="mb-4"
            v-for="provider in providers"
            :key="provider.id"
          >
            <provider-item
              :provider="provider"
              @click="goToProviderLink(provider)"
            />
          </b-col>
        </b-row>
      </b-container>
    </transition>
  </b-overlay>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ProviderItem from './ProviderItem'

export default {
  components: {
    ProviderItem
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('template', ['providers', 'template']),
    items() {
      return [{ text: 'Providers', to: '/providers' }, { text: this.template }]
    }
  },
  methods: {
    ...mapActions('template', ['getProviders']),
    async fetchProviders() {
      this.loading = true
      await this.getProviders(this.$route.params.id)
      this.loading = false
    }
  },
  mounted() {
    this.fetchProviders()
  }
}
</script>
